import {
    createRouter,
    createWebHashHistory
} from 'vue-router'
import login from '../components/usermanage/login'

import forgotpassword from '../components/usermanage/forgotpassword'
import regist from '../components/usermanage/registration'
import resetpassword from '../components/usermanage/rp'
import querymap from '../components/querymap'
import dpage from '../components/downloadpage'
import userprofile from '../components/usermanage/userprofileedit'
import stopservice from '../components/unavailable'
import vduser from '../components/usermanage/vduser.vue'
import about from '../components/about.vue'
// import myhome from '../components/myhome.vue'
import reportsandstats from '../components/Exhibition/reportsandstats.vue'

import userguide from '../components/userguide/userguide.vue'
import indexpage from '../components/index.vue'
const routes = [{
        path: '/login',
        name: 'login',
        component: login,
        meta: {
            title: '卫星看地球-登陆'
        }
    },
    {
        path: '/',
        redirect: 'index',
    },
    {
        path: '/forgotpassword',
        name: 'forgotpassword',
        component: forgotpassword
    },
    {
        path: '/dpage',
        name: 'dpage',
        component: dpage
    },
    {
        path: '/querymap',
        name: 'querymap',
        component: querymap
    },
    {
        path: '/about',
        name: 'about',
        component: about
    },
    {
        path:'/index',
        name:'index',
        component:indexpage
    },
    {
        path: '/reportsandstats',
        name: 'reportsandstats',
        component: reportsandstats
    },
    {
        path: '/regist',
        name: 'regist',
        component: regist,
        meta: {
            title: 'register'
        }
    },
    {
        path: '/rp',
        name: 'rp',
        component: resetpassword
    },
    {
        path: '/stopservice',
        name: 'stopservice',
        component: stopservice
    },
    {
        path: '/userprofile',
        name: 'userprofile',
        component: userprofile
    },
    {
        path: '/vduser',
        name: 'vduser',
        component: vduser
    },
    {
        path:'/userguide',
        name:'userguide',
        component:userguide
    },
    
    // {
    //     path: '/myhome',
    //     name: 'myhome',
    //     component: myhome,
    //     children: [{
    //             path: '',
    //             component: gf1
    //         }, {
    //             path: 'gf1', // 注意点：路径前面不要带/，否则无法跳转，在这里吃过亏
    //             name: 'gf1',
    //             component: gf1
    //         },
    //         {
    //             path: 'gf2', // 注意点：路径前面不要带/，否则无法跳转，在这里吃过亏
    //             name: 'gf2',
    //             component: gf2
    //         },
    //         {
    //             path: 'gf6', // 注意点：路径前面不要带/，否则无法跳转，在这里吃过亏
    //             name: 'gf6',
    //             component: gf6
    //         }
    //     ]
    // }
]

const router = createRouter({
    linkActiveClass: 'active',
    history: createWebHashHistory(process.env.BASE_URL),
    routes
})

export default router